import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserGroupListingComponent } from './user-group-listing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ControlDisabledDirectiveModule } from 'src/app/libs/ui/directives/control-disabled/control-disabled-directive.module';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { SortByModule } from 'src/app/libs/ui/pipes/sort-by/sort-by.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { HideAccessModule } from 'src/app/libs/ui/directives/hide-access/hide-access.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [UserGroupListingComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ControlDisabledDirectiveModule,
    SharedLayoutModule,
    WithTooltipModule,
    SortByModule,
    HideAccessModule,
    TranslateModule
  ],
  exports: [UserGroupListingComponent],
})
export class UserGroupListingModule {}
